/** Dedupe sample test entries (breadcrumb, QAQC detail, samples table). */

export function normalizeSampleTestTypeKey(type) {
  const t = String(type ?? "")
    .toLowerCase()
    .replace(/[\s_-]/g, "");
  if (!t || t === "unknown") return "";
  if (t === "compositiontest") return "compositiontests";
  if (t.endsWith("tests")) return t;
  if (t.endsWith("test")) return `${t}s`;
  return t;
}

export function sampleTestUniqueKey(test) {
  if (!test || typeof test !== "object") return "";
  const type = normalizeSampleTestTypeKey(
    test.testType || test.TestType || test.test_type || test.type
  );
  const id = String(test.ID ?? test.id ?? test.testId ?? test._id ?? "").trim();
  if (type && id) return `${type}::${id}`;
  if (id) return `id::${id}`;
  return "";
}

export function dedupeSampleTests(tests) {
  if (!Array.isArray(tests) || tests.length === 0) return [];
  const seen = new Set();
  const out = [];
  for (const test of tests) {
    if (!test) continue;
    const key = sampleTestUniqueKey(test);
    if (key) {
      if (seen.has(key)) continue;
      seen.add(key);
    }
    out.push(test);
  }
  return out;
}

export function dedupeSampleTestArray(tests) {
  return dedupeSampleTests(tests);
}
